import styled from "styled-components";

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  user-select: none;
  margin-bottom: 4px;
  width: fit-content;
  -webkit-tap-highlight-color: transparent;
`;
